import React, { useState, useEffect } from "react";

import db from "../../../services/query";
import lbl from "../../../data/Labels.json";
import PrintHeader from "../common/PrintHeader";
import Chart from "./_Chart";
import { formatPrintMoney } from "../financePrintUtils";
import {
    ReceiptAmountIcon,
    ReceiptCalendarIcon,
    ReceiptDocIcon,
    ReceiptUserIcon,
} from "../teacher-salary-report/_ReceiptDetailIcons";

const ExpensesPaymentReceipt = (props) => {

    const {type, account, subAccount, receipt_id, halfYear} = props.match.params;

    const [payment, setPayment] = useState({});
    const [budget, setBudget] = useState({});
    const [halfYearName, setHalfYearName] = useState("");


    let printHeadTexts = [
        'معاونیت امور اداری و مالی',
        'مدیریت مالی'
    ];

    let title = 'سند پرداخت';

    useEffect(async () => {
        const ac = new AbortController();
        requestData();
        return () => ac.abort();
    }, []);


    const requestData = async () => {
        // get expense
        let query = `expenses/types/${type}/accounts/${account}/subAccounts/${subAccount}/expenses?halfYearId=${halfYear}`;
        // get summary
        let query2 = `expenses/types/${type}/accounts/${account}/subAccounts?halfYearId=${halfYear}`;

        await db.getAll(query).then(({ data }) => {
            if (data.data)
                for (let p of data.data)
                    if (p.id == receipt_id)  setPayment(p);
        });

        await db.getAll(query2).then(({ data }) => {
            if (data.data)
                for (let p of data.data)
                    if (p.id == subAccount)  setBudget(p);
        });

        await db.getAll("dropdowns/halfYears").then(({ data }) => {
            const rows = data?.data || [];
            const match = rows.find((r) => String(r.id) === String(halfYear) || String(r.half_year_id) === String(halfYear));
            if (match) setHalfYearName(match.half_year || match.name || match.label || "");
        });
    };

    const detailRows = [
        { label: 'تاریخ', value: payment?.payment_date ?? '', Icon: ReceiptCalendarIcon },
        { label: 'پرداخت کننده', value: payment?.paid_by_staff ?? '', Icon: ReceiptUserIcon },
        { label: 'ريفرنس نمبر', value: payment?.bank_ref_no ?? '', Icon: ReceiptDocIcon },
        {
            label: 'مبلغ',
            value: payment?.amount != null && payment?.amount !== '' ? formatPrintMoney(payment.amount) : '',
            Icon: ReceiptAmountIcon,
            bold: true,
        },
    ];

    return (
        <main className="main-print-wrapper payment-receipt-print">
            <PrintHeader
                title={title}
                subtitle={payment?.half_year || payment?.halfYear || halfYearName || ""}
                date={" "}
                printHeadTexts={printHeadTexts}
                landscape
            />

            <div style={{display: "grid", gap: "10px", marginBottom: "5px"}}>
                <div className="print-finance-top-row" style={{display: "grid", gridTemplateColumns: "auto 70%", gap: "10px"}}>
                    <div className="report-summary-area white-background-with-border">
                        <Chart data={budget && budget}/>
                    </div>
                    <div className="white-background-with-border print-finance-profile-panel">
                        <div className="overall-summary">
                            <div className="wrapper">
                                <p>{lbl.OverallBalance}</p>
                                <h2 className="print-ltr-amount">{formatPrintMoney(budget?.balance)}</h2>
                            </div>
                        </div>
                        <div className="print-finance-profile-row print-finance-profile-row--info-only">
                            <div className="print-finance-profile-meta">
                                <div className="wrapper">
                                    <h3>{budget?.expense_account}</h3>
                                    <p>{budget?.name}</p>
                                    <p>{budget?.budget_code}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Same as teacher salary receipt: توضيحات left, field cards right. */}
            <div className="print-finance-details-row" style={{paddingTop: "20px", display: "grid", gridTemplateColumns: "60% auto", gap: "20px"}}>
                <div className="receipt-sub-card-container receipt-remark-wrap" style={{height: "100%"}}>
                    <div className="sub-card receipt-remark-card" style={{height: "100%", display: "grid", gridTemplateColumns: "1fr auto", alignItems: "center", columnGap: "12px"}}>
                        <p className="content content-rtl" style={{padding: "0 5px"}}>{payment?.remark ?? ''}</p>
                        <p className="label">{'توضيحات'}</p>
                    </div>
                </div>

                <div className="receipt-sub-card-container receipt-field-cards">
                    {detailRows.map(({ label, value, Icon, bold }) => (
                        <div key={label} className={`sub-card receipt-field-card${bold ? " bold" : ""}`}>
                            <span className="receipt-detail-icon" aria-hidden="true">
                                <Icon />
                            </span>
                            <p className="content">{value}</p>
                            <p className="label">{label}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div style={{display: "grid", gridTemplateColumns: "auto auto auto", paddingTop: "50px"}}>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "80%"}}>
                            <hr/>
                            <p>نام و امضاء تایید کننده</p>
                        </div>
                    </div>
                </div>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "80%"}}>
                            <hr/>
                            <p>نام و امضاء پرداخت کننده</p>
                        </div>
                    </div>
                </div>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "80%"}}>
                            <hr/>
                            <p>نام و امضاء گیرنده</p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default ExpensesPaymentReceipt;
